
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","viewBox":"0 0 3000 3000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"i-comet counterclockwise",attrs:{"stroke":"#fff","stroke-width":"171","d":"M960.229 2292.77a980.98 980.98 0 0 0 624.601 187.08 980.98 980.98 0 0 0 603.91-245.79 980.974 980.974 0 0 0-283.57-1643.726 980.97 980.97 0 0 0-651.36-29.237 980.95 980.95 0 0 0-525.815 385.551 980.98 980.98 0 0 0-167.968 630.012"}}),_c('path',{staticClass:"i-neptune clockwise",attrs:{"stroke":"#F1FCFC","stroke-dasharray":"4 4","stroke-width":"171","d":"M1751.49 838.705a707.5 707.5 0 0 1 314.74 237.105 707.47 707.47 0 0 1 139.09 368.71 707.5 707.5 0 0 1-79.72 385.91 707.46 707.46 0 0 1-273.81 283.41 707.51 707.51 0 0 1-1004.029-339.72 707.5 707.5 0 0 1-45.467-391.44"}}),_c('g',{staticClass:"i-jupiter clockwise",attrs:{"stroke":"#fff","stroke-width":"2"}},[_c('circle',{staticClass:"i-head",attrs:{"cx":"989.359","cy":"1570.62","r":"9","transform":"rotate(-2.098 989.359 1570.62)"}}),_c('path',{staticClass:"i-tail",attrs:{"d":"M1677.15 1985.85a516.5 516.5 0 0 1-224.13 28.96 516.5 516.5 0 0 1-215.04-69.5 516.6 516.6 0 0 1-164.78-154.66 516.6 516.6 0 0 1-82.977-210.21"}})])])
          )
        }
      }
    